import { Schema } from '@core/data/dto/schema';
import { TipSource } from './tip-source';

export const TipSourcesResponseSchema = {
    selected: Schema.String,
    sources: [TipSource]
};
